module.exports = __webpack_public_path__ + "static/media/offlinetags.1a89cae3.svg";